var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 81 81",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1255,-338)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.09459,0,0,1.09459,-112.243,178.189)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -1007,
    cy: 183,
    r: 37,
    style: {
      fill: "white"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -1007,
    cy: 183,
    r: 37
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.511144,0,0,0.511144,-3513.67,-3165.44)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.29787,0,0,2.60426,-5203.31,-9380.63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4400,6130C4400,6130 4390.66,6131.22 4386.55,6131.75C4385.48,6131.89 4384.71,6132.73 4384.78,6133.69C4385.14,6138.57 4386.15,6152.54 4386.36,6155.46C4386.39,6155.82 4386.37,6156.18 4386.31,6156.54C4386,6158.46 4384.93,6165.11 4384.41,6168.28C4384.25,6169.28 4384.91,6170.24 4385.98,6170.58C4389.11,6171.57 4395.39,6173.55 4398.37,6174.49C4399.42,6174.82 4400.58,6174.82 4401.63,6174.49C4404.61,6173.55 4410.89,6171.57 4414.02,6170.58C4415.09,6170.24 4415.75,6169.28 4415.59,6168.28C4415.07,6165.1 4414,6158.45 4413.69,6156.53C4413.63,6156.18 4413.61,6155.82 4413.64,6155.46C4413.84,6152.55 4414.84,6138.56 4415.18,6133.68C4415.25,6132.73 4414.48,6131.89 4413.41,6131.75C4409.32,6131.22 4400,6130 4400,6130Z",
    style: {
      fill: "rgb(234,178,140)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.64479,-2.84887,2.25535,1.30213,-16178.1,11095.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4386.79,6137.57C4386.79,6136.41 4386.41,6135.31 4385.74,6134.52C4385.07,6133.73 4384.16,6133.34 4383.25,6133.43C4378.63,6133.87 4370.81,6134.63 4368.02,6134.9C4367.44,6134.96 4367,6135.56 4367,6136.29C4367,6137.04 4367,6137.97 4367,6138.72C4367,6139.44 4367.44,6140.05 4368.01,6140.11C4370.79,6140.4 4378.6,6141.22 4383.23,6141.71C4384.15,6141.81 4385.05,6141.41 4385.73,6140.63C4386.41,6139.84 4386.79,6138.73 4386.79,6137.57C4386.79,6137.57 4386.79,6137.57 4386.79,6137.57Z",
    style: {
      fill: "rgb(234,178,140)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.29266,-3.02497,-2.39477,1.02335,25308.9,13578.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4386.79,6137.57C4386.79,6136.41 4386.41,6135.31 4385.74,6134.52C4385.07,6133.73 4384.16,6133.34 4383.25,6133.43C4378.63,6133.87 4370.81,6134.63 4368.02,6134.9C4367.44,6134.96 4367,6135.56 4367,6136.29C4367,6137.04 4367,6137.97 4367,6138.72C4367,6139.44 4367.44,6140.05 4368.01,6140.11C4370.79,6140.4 4378.6,6141.22 4383.23,6141.71C4384.15,6141.81 4385.05,6141.41 4385.73,6140.63C4386.41,6139.84 4386.79,6138.73 4386.79,6137.57C4386.79,6137.57 4386.79,6137.57 4386.79,6137.57Z",
    style: {
      fill: "rgb(234,178,140)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.9659,0.848505,-0.865956,7.10916,-20466.9,-40566.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4402,6096C4404.21,6096 4406,6097.79 4406,6100C4406,6101.28 4408.31,6107.07 4406.16,6109.49C4404.59,6111.26 4398.6,6109.99 4397.67,6109.99C4395.46,6109.99 4398,6102.21 4398,6100C4398,6097.79 4399.79,6096 4402,6096Z",
    style: {
      fill: "rgb(255,167,98)"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4402,6096C4404.21,6096 4406,6097.79 4406,6100C4406,6101.28 4408.31,6107.07 4406.16,6109.49C4404.59,6111.26 4398.6,6109.99 4397.67,6109.99C4395.46,6109.99 4398,6102.21 4398,6100C4398,6097.79 4399.79,6096 4402,6096Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,5.15386,6.90909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4400.75,6092.6C4401.58,6090.56 4406,6097.79 4406,6100C4406,6101.28 4408.31,6107.07 4406.16,6109.49C4404.59,6111.26 4398.6,6109.99 4397.67,6109.99C4395.46,6109.99 4398.31,6102.19 4398,6100C4397.65,6097.52 4399.86,6094.82 4400.75,6092.6Z",
    style: {
      fill: "rgb(216,132,66)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.58515,0.314893,-0.499028,4.09683,-3407.86,-19907.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4396,6125L4395,6130C4398.33,6131.9 4401.67,6131.93 4405,6130L4404,6125L4396,6125Z",
    style: {
      fill: "rgb(234,178,140)"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4396,6125L4395,6130C4398.33,6131.9 4401.67,6131.93 4405,6130L4404,6125L4396,6125Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.70294,0,1821.03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4390,6105.4C4390,6103.97 4390.63,6102.6 4391.76,6101.58C4392.89,6100.57 4394.42,6100 4396.02,6100L4403.98,6100C4405.58,6100 4407.11,6100.57 4408.24,6101.58C4409.37,6102.6 4410,6103.97 4410,6105.4L4410,6118.81C4410,6119.57 4409.68,6120.32 4409.11,6120.89C4407.74,6122.26 4405.05,6124.95 4402.94,6127.06C4402.19,6127.81 4401.12,6128.24 4400,6128.24C4398.88,6128.24 4397.81,6127.81 4397.06,6127.06C4394.95,6124.95 4392.26,6122.26 4390.89,6120.89C4390.32,6120.32 4390,6119.57 4390,6118.81L4390,6105.4Z",
    style: {
      fillOpacity: 0.11
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.58515,0.314893,-0.314893,2.58515,-4540.73,-10637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4412,6110.03C4412,6109.75 4411.89,6109.49 4411.7,6109.3C4411.51,6109.11 4411.25,6109 4410.97,6109L4410,6109L4409.31,6113L4410,6113C4411.11,6113 4412,6112.11 4412,6111C4412,6110.66 4412,6110.32 4412,6110.03Z",
    style: {
      fill: "rgb(179,97,42)"
    }
  }), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4412,6110.03C4412,6109.75 4411.89,6109.49 4411.7,6109.3C4411.51,6109.11 4411.25,6109 4410.97,6109L4410,6109L4409.31,6113L4410,6113C4411.11,6113 4412,6112.11 4412,6111C4412,6110.66 4412,6110.32 4412,6110.03Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.5,-1,3055.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4412,6110.14C4412,6109.84 4411.94,6109.55 4411.83,6109.33C4411.73,6109.12 4411.58,6109 4411.43,6109C4410.84,6109 4410,6109 4410,6109L4410,6113C4410,6113 4410.26,6113.01 4410.59,6113.03C4410.96,6113.05 4411.32,6112.77 4411.59,6112.25C4411.85,6111.73 4412,6111.03 4412,6110.28C4412,6110.23 4412,6110.19 4412,6110.14Z",
    style: {
      fill: "rgb(195,111,55)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.58515,0.314893,-0.314893,2.58515,-4533.63,-10636.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4390,6109L4389,6109C4388.45,6109 4388,6109.45 4388,6110C4388,6110.3 4388,6110.65 4388,6111C4388,6112.11 4388.9,6113 4390,6113C4390,6113 4390.5,6113 4390.5,6113L4390,6109Z",
    style: {
      fill: "rgb(222,137,81)"
    }
  }), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4390,6109L4389,6109C4388.45,6109 4388,6109.45 4388,6110C4388,6110.3 4388,6110.65 4388,6111C4388,6112.11 4388.9,6113 4390,6113C4390,6113 4390.5,6113 4390.5,6113L4390,6109Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.5,1,3055.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4390,6109L4388.37,6109C4388.27,6109 4388.18,6109.08 4388.11,6109.22C4388.04,6109.35 4388,6109.54 4388,6109.73L4388,6110.31C4388,6111.03 4388.14,6111.71 4388.39,6112.21C4388.65,6112.72 4388.99,6113 4389.34,6113L4390,6113L4390,6109Z",
    style: {
      fill: "rgb(195,111,55)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.42276,0.295112,-0.248538,2.0404,-4228.1,-7221.02)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4390.73,6108.77C4390.73,6103.93 4393.93,6100 4398.77,6100C4399.59,6100 4400.41,6100 4401.23,6100C4406.07,6100 4409.27,6103.93 4409.27,6108.77C4409.27,6109.76 4409.01,6112.55 4408.71,6115.44C4408.38,6120.38 4405.6,6124.6 4401.65,6126.19C4401.65,6126.21 4401.65,6126.21 4401.65,6126.21C4400.58,6126.64 4399.42,6126.64 4398.35,6126.21C4398.35,6126.21 4398.35,6126.21 4398.35,6126.21C4394.39,6124.62 4391.61,6120.39 4391.27,6115.44C4390.99,6112.54 4390.73,6109.76 4390.73,6108.77Z",
    style: {
      fill: "rgb(255,193,151)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.77421,0.216114,-0.216114,1.77421,7103.85,6295.11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1212.31,285C-1205.27,283.17 -1197.27,280.57 -1194.5,275.5C-1192.34,279.652 -1191.65,282.673 -1187,285.056L-1186,281L-1192,273L-1201,272L-1208,274L-1212,278L-1212.31,285Z",
    style: {
      fill: "rgb(255,167,98)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.19572,0,0,1.19572,-465.822,6.24734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-475,241C-459,247.543 -443,247.79 -427,241L-427,178.001C-427,178.001 -429.246,171.083 -430.593,166.931C-431.206,165.043 -432.782,163.627 -434.725,163.219C-438.784,162.368 -445.337,160.993 -445.337,160.993C-447.906,167.159 -455.067,166.984 -456.034,160.993L-467,163.077C-465.064,165.251 -465.192,170.339 -466.585,176L-468,203L-475,241Z",
    style: {
      fill: "rgb(14,164,233)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.122773,2.91754,-2.31769,-0.0975312,13723.6,-11900.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4345.15,6134.48C4345.01,6134.19 4344.84,6134.01 4344.57,6134.01C4344.14,6134.01 4343.45,6134.01 4342.9,6134C4342.66,6134 4342.43,6134.12 4342.26,6134.33C4342.1,6134.54 4342,6134.83 4342,6135.13C4342,6135.64 4342,6136.24 4342,6136.76C4342,6137.08 4342.11,6137.38 4342.29,6137.6C4342.48,6137.81 4342.73,6137.91 4342.98,6137.88C4343.37,6137.84 4343.92,6137.74 4344.32,6137.66C4344.61,6137.61 4344.88,6137.44 4345.08,6137.17C4345.25,6136.94 4345.53,6136.71 4345.91,6136.72L4345.86,6135.14C4345.86,6135.14 4345.36,6134.9 4345.15,6134.48Z",
    style: {
      fill: "rgb(234,178,140)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.91358,0,0,0.91358,89.6781,12.5616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1231.43,184.139C-1231.41,183.502 -1230.88,183 -1230.24,183C-1228.53,183 -1225.32,183 -1223.62,183C-1222.99,183 -1222.47,183.489 -1222.43,184.116C-1222.25,186.965 -1221.76,194.668 -1221.4,200.243C-1221.3,201.838 -1220.52,203.315 -1219.27,204.306C-1218.01,205.296 -1216.4,205.706 -1214.82,205.435C-1210.88,204.755 -1206.5,204 -1206.5,204L-1213.92,230.061L-1227.5,223.5C-1227.5,223.5 -1228.24,222.617 -1229.18,221.505C-1231.58,218.647 -1232.83,214.99 -1232.66,211.258C-1232.28,202.98 -1231.62,188.315 -1231.43,184.139Z",
    style: {
      fill: "rgb(14,164,233)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58447,0.235,-0.730635,4.92625,-3429.25,-31066.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4345,6132.37C4345,6132.24 4344.66,6132.13 4344.25,6132.13C4344.25,6132.13 4344.25,6132.13 4344.25,6132.13C4343.84,6132.13 4343.5,6132.24 4343.5,6132.37C4343.5,6132.85 4343.5,6133.88 4343.5,6133.88C4343.5,6133.95 4343.67,6134.01 4343.88,6134.01L4344.62,6134.01C4344.83,6134.01 4345,6133.95 4345,6133.88L4345,6132.37Z",
    style: {
      fill: "rgb(234,178,140)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.6007,0.0595207,-0.177598,4.77617,-6894.14,-29386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4345,6132.38C4345,6132.24 4344.66,6132.13 4344.25,6132.13C4344.25,6132.13 4344.25,6132.13 4344.25,6132.13C4343.84,6132.13 4343.5,6132.24 4343.5,6132.38C4343.5,6132.86 4343.5,6133.88 4343.5,6133.88C4343.5,6133.95 4343.67,6134.01 4343.88,6134.01L4344.62,6134.01C4344.83,6134.01 4345,6133.95 4345,6133.88L4345,6132.38Z",
    style: {
      fill: "rgb(234,178,140)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5965,-0.130303,0.431941,5.29224,-10617.1,-31725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4345,6132.35C4345,6132.22 4344.67,6132.12 4344.27,6132.12C4344.26,6132.12 4344.24,6132.12 4344.23,6132.12C4343.83,6132.12 4343.5,6132.22 4343.5,6132.35C4343.5,6132.82 4343.5,6133.88 4343.5,6133.88C4343.5,6133.95 4343.67,6134.01 4343.88,6134.01L4344.62,6134.01C4344.83,6134.01 4345,6133.95 4345,6133.88L4345,6132.35Z",
    style: {
      fill: "rgb(234,178,140)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.57929,-0.267591,0.840461,4.96032,-13049.9,-29089.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4345,6132.37C4345,6132.24 4344.67,6132.13 4344.26,6132.13C4344.25,6132.13 4344.25,6132.13 4344.24,6132.13C4343.83,6132.13 4343.5,6132.24 4343.5,6132.37C4343.5,6132.84 4343.5,6133.88 4343.5,6133.88C4343.5,6133.95 4343.67,6134.01 4343.88,6134.01L4344.62,6134.01C4344.83,6134.01 4345,6133.95 4345,6133.88L4345,6132.37Z",
    style: {
      fill: "rgb(234,178,140)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23408,2.25168,-3.62162,1.98491,15824.7,-21780.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4345,6132.7C4345,6132.57 4344.92,6132.46 4344.78,6132.37C4344.64,6132.28 4344.45,6132.23 4344.25,6132.23L4344.25,6132.23C4344.05,6132.23 4343.86,6132.28 4343.72,6132.37C4343.58,6132.46 4343.5,6132.57 4343.5,6132.7L4343.5,6133.78C4343.5,6133.9 4343.67,6134.01 4343.88,6134.01L4344.62,6134.01C4344.83,6134.01 4345,6133.9 4345,6133.78L4345,6132.7Z",
    style: {
      fill: "rgb(234,178,140)"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/logo_blue.c3e420fd06c6514c915630fc2290ad1d.svg";
export { ForwardRef as ReactComponent };